import React, { createContext, useContext, useState } from "react";

const CreateContext = createContext({
  toggleVisualization: () => {},
  isVisualizationOn: false,
});
const PermissionsVisualizerContext: React.FC = ({ children }) => {
  const [isVisualizationOn, setIsVisualizationOn] = useState(false);

  const toggleVisualization = () => {
    setIsVisualizationOn(!isVisualizationOn);
  };

  return (
    <CreateContext.Provider value={{ toggleVisualization, isVisualizationOn }}>
      {children}
    </CreateContext.Provider>
  );
};

export const usePermissionsVisualizerContext = () => useContext(CreateContext);
export default PermissionsVisualizerContext;
